// extracted by mini-css-extract-plugin
export default {"slideContainer":"_813c480ca9 _940b094808 f19c1ca42a","slideImage":"e6d3413a06"};